angular.module("analytics.mixpanel").directive("analyticsOn", [
  "AnalyticsService",
  function (analyticsService) {
    return {
      restrict: "A",
      scope: {
        anAction: "@",
        anProperties: "=",
        anStartTimer: "@",
        anStartTimerFor: "@",
      },
      link: function (scope, element, attr) {
        element.on(attr.analyticsOn || DEFAULT_EVENT, function () {
          if (scope.anStartTimer !== undefined) {
            analyticsService.startEventTimer(scope.anAction);
          } else {
            analyticsService.track(scope.anAction, { ...scope.anProperties });
          }
          if (scope.anStartTimerFor) {
            analyticsService.startEventTimer(scope.anStartTimerFor);
          }
        });
      },
    };
  },
]);
